import React from 'react'

export const TwitterIcon = ({ className }: { className?: string }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <path
        d="M24 4.3C23.1 4.7 22.2 5 21.2 5.1C22.2 4.5 23 3.5 23.4 2.4C22.4 3 21.4 3.4 20.3 3.6C19.4 2.6 18.1 2 16.7 2C14 2 11.8 4.2 11.8 6.9C11.8 7.3 11.8 7.7 11.9 8C7.7 7.8 4.1 5.8 1.7 2.8C1.2 3.6 1 4.4 1 5.3C1 7 1.9 8.5 3.2 9.4C2.4 9.4 1.6 9.2 1 8.8C1 8.8 1 8.8 1 8.9C1 11.3 2.7 13.3 4.9 13.7C4.5 13.8 4.1 13.9 3.6 13.9C3.3 13.9 3 13.9 2.7 13.8C3.3 15.8 5.1 17.2 7.3 17.2C5.6 18.5 3.5 19.3 1.2 19.3C0.8 19.3 0.4 19.3 0 19.2C2.2 20.6 4.8 21.4 7.5 21.4C16.6 21.4 21.5 13.9 21.5 7.4C21.5 7.2 21.5 7 21.5 6.8C22.5 6.1 23.3 5.2 24 4.3Z"
        fill="#C4CAD6"
      />
    </svg>
  )
}
